var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Resource, { CharacteristicType } from "./Resource";
import Profile from "./Profile";
import Credential from "./Credential";
var User = /** @class */ (function (_super) {
    __extends(User, _super);
    function User(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this, obj) || this;
        _this.profiles = [];
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        User.buildFromJson(_this, obj);
        return _this;
    }
    User.buildFromJson = function (instance, json) {
        if (json) {
            for (var prop in json) {
                if (json.hasOwnProperty(prop)) {
                    if (prop === 'credentials') {
                        instance[prop] = new Credential(json[prop]);
                    }
                    else if (prop === 'profiles') {
                        instance[prop] = [];
                        for (var _i = 0, _a = json[prop]; _i < _a.length; _i++) {
                            var subProp = _a[_i];
                            instance[prop].push(new Profile(subProp));
                        }
                    }
                }
            }
        }
    };
    User.prototype.exportToJson = function (avoidEmptyValue) {
        if (avoidEmptyValue === void 0) { avoidEmptyValue = false; }
        var JSONUser = _super.prototype.exportToJson.call(this);
        if (this.credentials) {
            JSONUser["credentials"] = this.credentials.exportToJson();
        }
        JSONUser.profiles = [];
        for (var _i = 0, _a = this.profiles; _i < _a.length; _i++) {
            var profile = _a[_i];
            JSONUser.profiles.push(profile.exportToJson());
        }
        return JSONUser;
    };
    Object.defineProperty(User.prototype, "password", {
        /** Setter & Getter of Password **/
        get: function () {
            if (this.credentials && this.credentials.password) {
                return this.credentials.password;
            }
            else {
                return '';
            }
        },
        set: function (value) {
            if (this.credentials === undefined) {
                this.credentials = new Credential();
            }
            this.credentials.password = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "first_name", {
        get: function () {
            return this.get(CharacteristicType.FIRST_NAME);
        },
        set: function (value) {
            this.set(CharacteristicType.FIRST_NAME, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "last_name", {
        get: function () {
            return this.get(CharacteristicType.LAST_NAME);
        },
        set: function (value) {
            this.set(CharacteristicType.LAST_NAME, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "birth_date", {
        get: function () {
            return this.get(CharacteristicType.BIRTH_DATE);
        },
        set: function (value) {
            this.set(CharacteristicType.BIRTH_DATE, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "nationality", {
        get: function () {
            return this.get(CharacteristicType.NATIONALITY);
        },
        set: function (value) {
            this.set(CharacteristicType.NATIONALITY, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "country_of_residence", {
        get: function () {
            return this.get(CharacteristicType.COUNTRY_OF_RESIDENCE);
        },
        set: function (value) {
            this.set(CharacteristicType.COUNTRY_OF_RESIDENCE, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "business_name", {
        get: function () {
            return this.get(CharacteristicType.BUSINESS_NAME);
        },
        set: function (value) {
            this.set(CharacteristicType.BUSINESS_NAME, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "address", {
        get: function () {
            return this.get(CharacteristicType.ADDRESS);
        },
        set: function (value) {
            this.set(CharacteristicType.ADDRESS, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "gender", {
        get: function () {
            return this.get(CharacteristicType.GENDER);
        },
        set: function (value) {
            this.set(CharacteristicType.GENDER, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "fullname", {
        get: function () {
            var _a;
            if (this.first_name !== null) {
                return ((_a = this.first_name) !== null && _a !== void 0 ? _a : "") + (this.last_name ? (this.first_name ? " " : "") + this.last_name : "");
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    return User;
}(Resource));
export default User;
//# sourceMappingURL=User.js.map